export default __webpack_public_path__ + "static/media/csharp.fb4bfd40.png";